<template>
    <div class="container">
        <div class="mt-2 row">
            <h2>Admin Console</h2>
        </div>

        <amf-checkbox align="right" label="Multiple Commands" v-model="enableMultipleCommands" style="padding-left:0"/>

        <div class="mt-2 row" v-if="enableMultipleCommands">
            <amf-textarea v-model="multipleCommands" :rows="8" :columns="3" style="padding-left:0" class="col-12"></amf-textarea>
        </div>
        <div class="mt-2 row" v-if="!enableMultipleCommands">
            <input ref="inputText" v-model="command" @keyup="keyup" @keydown.tab.prevent="onTab" @keydown.enter.prevent="run" class="form-control col-12" placeholder="Enter command with parameters" />

            <div class="list-group w-100">
              <a href="#" @click.prevent="selectCommandFromListGroup(command.shortSyntax)" v-for="command in filteredDefinitions" class="list-group-item list-group-item-action">
                <div>{{command.syntax}}</div>
                <p class="mb-1 command-description">{{command.description}}</p>
              </a>
            </div>
        </div>
        <div class="mt-2 row">
            <amf-button class="btn-default col-1" :onClick="showList">List</amf-button>
            <amf-button class="btn-success offset-10 col-1" :onClick="run">Run</amf-button>
        </div>
        <div class="mt-2 row">
            <hr>
            <pre class="form-control col-12" style="min-height: 300px">{{output}}</pre>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        data() {
            return {
                helpText: null,
                command: null,
                enableMultipleCommands: null,
                multipleCommands: null,
                output: null,
                definitions: [],
                filteredDefinitions: [],
                amfOptions: { layout: "custom" }
            }
        },
        methods: {
            findCommands() {
                if(this.command && this.command.length >= 3) {
                    let search = this.command.trim();
                    return this.definitions.filter(x => x.shortSyntax.includes(search));
                }
                else return [];
            },
            onTab() {
                let result = this.findCommands();
                if(result.length) {
                    this.command = result[0].shortSyntax + ' ';
                    this.filteredDefinitions = result[0];
                }
            },
            keyup() {
                if(!this.command || this.command.length === 0) {
                    this.filteredDefinitions = [];
                }

                let commandsFound = this.findCommands();

                if (this.filteredDefinitions.length === 1 && commandsFound.length === 0) return;

                this.lookupHelpText();
            },
            lookupHelpText() {
                this.filteredDefinitions = this.findCommands();
            },
            getCommands() {
                if (!this.enableMultipleCommands) return _.compact([this.command]);
                return (this.multipleCommands || []).split("\n").map(c => c.trim()).filter(c => c);
            },
            async run() {
                var commands = this.getCommands();
                if (commands.length == 0) return;
                var msg = commands.length == 1 ? "this command" : `these ${commands.length} commands`;
                if (!await modalService.confirm(`Are you sure you want to run ${msg}?`)) return;
                this.output = "Running...";
                var result = await romeApi.post("/command/run", { commands });
                this.output = result.join("\n");
            },
            async showList() {
                let result = await modalService.show('definitions-modal', DefinitionsModal, { width: 900, definitions: this.definitions });
                if(result) {
                    this.command = result;
                    this.lookupHelpText();
                    this.$refs.inputText.focus();
                }
            },
            async selectCommandFromListGroup(shortSyntax) {
              this.command = shortSyntax + ' ';
              this.lookupHelpText();
              this.$refs.inputText.focus();
            }
        },
        async created() {
            let results = await romeApi.get('command/list');
            this.definitions = results.map(r => {
                r.parameters = r.parameters.join(', ');
                return r;
            });
        },
        watch: {
            enableMultipleCommands() {
                this.command = null;
                this.multipleCommands = null;
            }
        }
    }

    const DefinitionsModal = Vue.component('definitions-modal', {
        props: ['definitions'],
        data() {
          return {
            categorySelected: null,
            categories: [],
            filteredCommands: []
          }
        },
        inject: ['closeModal'],
        computed: {
            readOnly() { return true; },
            title() {
                return 'Command Definitions';
            },
            getCategories() {
                return Array.from(new Set(this.definitions.map(d => d.category)))
                  .map(category => {
                    return {
                      id: category,
                      name: category
                    };
                  });
            }
        },
        created() {
          this.filteredCommands = this.definitions;
        },
        methods: {
            async close(command) {
                var result = command.shortSyntax + ' ';
                this.closeModal(result);
            },
            filterCommands() {
                if (this.categorySelected == null) return this.definitions;

                return this.definitions.filter(x => x.category === this.categorySelected);
            }
        },
        watch: {
          categorySelected() {
              this.filteredCommands = this.filterCommands();
          }
        },
        template: `
        <div style="height: 650px; overflow-y: scroll">
          <div class="col-4" style="padding-bottom: 10px">
            <label class="mb-1">Category</label>
            <select class="form-control" v-model="categorySelected">
              <option :value="null">--All categories--</option>
              <option v-for="category in getCategories" v-bind:value="category.name" :key="category.id">
                {{ category.name }}
              </option>
            </select>
          </div>

          <table class="table table-condensed">
            <thead>
              <th>Command</th>
            </thead>
            <tbody v-for="command in filteredCommands" :key="command.command">
              <tr>
                <td>
                  <div class="container">
                    <div id="domain" class="row align-items-center">
                      <div id="domain-description" style="background-color: lightslategray; border-radius: 3px; padding: 4px; text-align: center; display: inline; color: white; font-weight: bolder;">
                        {{ command.category }}
                      </div>
                      <a style="padding-left: 5px" href="#" @click.prevent="close(command)">{{ command.name }}</a>
                    </div>
                  </div>

                  <div>
                    <div id="description" style="padding-top: 10px">
                      <div id="syntax-title" style="padding-bottom: 5px; font-weight: bold;">
                        Description
                      </div>
                      <div>
                        {{ command.description }}
                      </div>
                    </div>

                    <div id="syntax" style="padding-top: 10px">
                      <div id="syntax-title" style="padding-bottom: 5px; font-weight: bold;">
                        Syntax
                      </div>
                      <div id="syntax-command" style="background-color: antiquewhite; border-radius: 3px; height: 100%; padding: 10px;">
                        {{ command.syntax }}
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>`
    })
</script>

<style lang="scss" scoped>
    .fixedHeight{
        overflow-y: scroll;
        max-height: 500px;
    }
    .command-description {
        color:slategray;
    }
</style>



// WEBPACK FOOTER //
// src/employer/AdminConsole.vue